/* eslint-disable */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import { COMMON } from '../../constants/strings';

import styles from './colToggler.styl';

@CSSModules(styles, { allowMultiple: true })
export default class ColToggler extends PureComponent {
  static propTypes = {
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
  };

  state = {
    expanded: null,
  };

  componentWillMount() {
    this.setState({ expanded: this.props.expanded });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ expanded: nextProps.expanded });
  }

  @autobind
  toggleCell() {
    const { onToggle } = this.props;

    onToggle
      ? onToggle()
      : this.setState({
          expanded: !this.state.expanded,
        });
  }

  render() {
    const { expanded } = this.state;

    return (
      <button
        styleName={classNames('toggler', {
          'toggler--expanded': expanded,
        })}
        onClick={this.toggleCell}
      >
        <FormattedMessage {...COMMON.collapse} />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/ColToggler.jsx